import React from 'react';

function Plus(props: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 9 9">
            <g fill={props.color} fillRule="evenodd">
                <rect width="1.4" height="9" x="3.8" rx=".7" />
                <rect width="1.4" height="9" x="3.8" rx=".7" transform="rotate(90 4.5 4.5)" />
            </g>
        </svg>
    );
}

export default Plus;
